// APP TEXT
export const FOOTER_TEXT = `Built by Octopus. Happy Deployments!`

// UI CONSTANTS
export const FOOTER_HEIGHT = 30

/**
 * The number of times to retry GET requests.
 */
export const GET_RETRIES = 5;